/**
 * External Dependencies
 */
import 'jquery';
import 'bootstrap';
import './partials/header';
import '@fortawesome/fontawesome-free/js/all'
import Swiper, { Navigation, Pagination } from 'swiper'
import 'lightgallery.js/dist/js/lightgallery'

$(document).ready(() => {

  $('.hamburger').click(() => {
    $('.nav--mobile').addClass('active')
    $('body').css('overflow', 'hidden')
  });

  $('.nav--mobile .close').click(() => {
    $('body').css('overflow', 'auto')
    $('.nav--mobile').removeClass('active')
  })

  // initialize swiper
  Swiper.use([Pagination, Navigation])
  new Swiper('.swiper-container', {
    slidesPerView: 1,
    spaceBetween: 15,
    breakpoints: {
      750: {
        slidesPerView: 2,
      },
      1000: {
        slidesPerView: 3,
      },
    },
    centerInsufficientSlides: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  })


  // Lightgallery
  $('.lightgallery').each((i, el) => lightGallery(el))


  // fit price cards always
  $('.price-slider .title').each((_, el) => {
    el = $(el)
    let width = parseInt(el.css('width'))
    width -= 2 * parseInt(el.css('padding-left'))
    const fontSize = parseInt(el.css('font-size'))
    const amountOfChars = el.text().trim().length
    const factor = width / (0.50 * fontSize * amountOfChars)

    if (0.7 * fontSize * amountOfChars > width) {
      const newSize = Math.min(fontSize, factor * fontSize)
      el.css('font-size', newSize + 'px')
    }
  })

  $('.content').each((i, el) => {
    const bg_color = $(el).data('bg-color')
    const text_color = $(el).data('text-color')

    $(el).find('h1,h2,h3,h4').css('background', bg_color).css('color', text_color)
  });
})


function invertColor(hex, bw) {
  if (hex.indexOf('#') === 0) {
    hex = hex.slice(1);
  }
  // convert 3-digit hex to 6-digits.
  if (hex.length === 3) {
    hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
  }
  if (hex.length !== 6) {
    throw new Error('Invalid HEX color.');
  }
  var r = parseInt(hex.slice(0, 2), 16),
    g = parseInt(hex.slice(2, 4), 16),
    b = parseInt(hex.slice(4, 6), 16);
  if (bw) {
    // http://stackoverflow.com/a/3943023/112731
    return (r * 0.299 + g * 0.587 + b * 0.114) > 186
      ? '#000'
      : '#fff';
  }
  // invert color components
  r = (255 - r).toString(16);
  g = (255 - g).toString(16);
  b = (255 - b).toString(16);
  // pad each with zeros and return
  return "#" + padZero(r) + padZero(g) + padZero(b);
}

function padZero(str, len) {
  len = len || 2;
  var zeros = new Array(len).join('0');
  return (zeros + str).slice(-len);
}

